export const FIRM_NAME = 'Beress & Zalkind PLLC';
export const FIRM_PHONE = '718-513-3588';
export const FIRM_OFFICE_PHONES = [
	{ office: 'New York', phone: '212-390-0325' },
	{ office: 'Brooklyn', phone: FIRM_PHONE },
	{ office: 'Florida', phone: '305-209-0500' },
];
export const FIRM_EMAIL = 'info@bzlawgroup.com';
export const FIRM_WEBSITE = 'www.bzlawgroup.com';
export const FIRM_CONTACT_LINE = `${FIRM_NAME} | ${FIRM_PHONE} | ${FIRM_EMAIL} | ${FIRM_WEBSITE}`;
